import { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Buttons from '../../../../../Atoms/Buttons/Buttons';
import styles from './LinkedUsers.module.scss';
import automaticAssignICon from '../../../../../../assets/Imagess/Users/UsersAssignment/automaticAssign.svg';
import ColoredButton from '../../../../../Atoms/Buttons/ColoredButtons/ColoredButton';
import AssignModal from '../../../../UsersAssignment/AssignModal';

const LinkedUsers = ({ users = [], refetch, setRefresh }) => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [isAssignUser, setIsAssignUser] = useState({
    isAssigned: false,
    assignTitle: 'Bulk Assign',
  });
  const [selectedItem, setSelectedItem] = useState([]);

  const getUserRoute = (type, id) => {
    switch (type) {
      case 'Lead':
        return `/home/interested/${id}`;
      case 'Prospect':
        return `/home/applicants/${id}`;
      case 'External Contact':
        return `/home/contact-details/${id}`;
      default:
        return '#';
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className={styles.contactDropdown} ref={dropdownRef}>
        <Buttons
          text='Linked Users'
          handleOnClick={() => setOpen((prev) => !prev)}
          className={styles.linkedUsers}
          rounded
        />

        {open && (
          <div className={styles.dropdown}>
            {users?.map((user) => (
              <div key={user?.id} className={styles.userRow}>
                <a
                  href={getUserRoute(user.type, user.id)}
                  className={styles.name}
                  target='blank'
                >
                  <div className={styles.mainLine}>
                    <span className={styles.type}>{user?.type}:</span>
                    <span className={styles.userName}>{user?.name}</span>
                  </div>

                  <div className={styles.assignedLine}>
                    Assigned To:
                    <span>
                      {user?.assignedTo ? user.assignedTo : 'Unassigned'}
                    </span>
                  </div>
                </a>

                <ColoredButton
                  title='Assign'
                  unfilled
                  rounded={true}
                  icon={automaticAssignICon}
                  handleOnClick={() => {
                    setIsAssignUser((prev) => ({
                      ...prev,
                      assignTitle: 'Assign User',
                      isAssigned: true,
                    }));
                    setSelectedItem([{ id: user.id }]);
                  }}
                  className={styles.linkedUsers}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      {isAssignUser.isAssigned && (
        <AssignModal
          handleOnClose={() =>
            setIsAssignUser((prev) => ({ ...prev, isAssigned: false }))
          }
          selected={selectedItem}
          setSelected={setSelectedItem}
          title={isAssignUser.assignTitle}
          refetch={() => (
            refetch(),
            setOpen(false),
            setRefresh((prev) => !prev)
          )}
        />
      )}
    </>
  );
};

export default LinkedUsers;
